// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"45":"29e477ccc724c672","706":"9f28a2795c80f694"}[chunkId] + ".js";
};